// CO2-savings factor lookup, per customer, from the denormalized customers_mcs[].
//
// Each customers_mcs entry now carries `savings_emission_factor` (kg CO2 saved
// per litre), resolved server-side from the customer's assigned fuel type and
// defaulting to B100 when unassigned. This helper centralises the lookup so no
// component hardcodes a factor.

// B100 fallback — matches the backend DEFAULT_FUEL_TYPE, used only if the entry
// is missing the field (e.g. stale Firestore doc before re-sync).
export const DEFAULT_SAVINGS_FACTOR = 2.97763;

/**
 * @param {number|string} mcsCustomerId
 * @param {Array<{mcs_customer_id:number, savings_emission_factor?:number}>} customersMcs
 * @returns {number} kg CO2 saved per litre for that customer
 */
export function savingsFactorFor(mcsCustomerId, customersMcs) {
  const id = Number(mcsCustomerId);
  const entry = (customersMcs || []).find((c) => Number(c.mcs_customer_id) === id);
  const f = entry?.savings_emission_factor;
  return typeof f === 'number' && !Number.isNaN(f) ? f : DEFAULT_SAVINGS_FACTOR;
}
